import api from "./api";

class ActivityLogAPI {

  async getActivityLog(headers) {

    const response = await api.get("/get_activity_log", { headers });
    return response;
  }
}

export default new ActivityLogAPI();
